export const screenSetsErrorMessages_EN = {
  email_already_exists:
    'An account with that email already exists - try <a href class="sign-in-link" style="font-size: inherit;" data-switch-screen="gigya-login-screen">signing in</a>',
  email_address_is_invalid: 'Invalid email address',
  please_enter_fieldname: 'Enter your %fieldname',
};
